import React from "react";

const Introduction = () => {
  return (
    <div className="introduction">
      <h1>Welcome to Cardboard UI</h1>
      <div>
        A ReactJS based Frontend component library for building fast & latest
        web-interfaces
      </div>
      <br />
      <br />
      <br />
      <div>
        <strong>By - Shivaansh Agarwal</strong>
      </div>
    </div>
  );
};

export default Introduction;
